
import {
    ENV_DEVELOPMENT,
} from '@vfde-fe/sails_core';

/**
 * Export MAIN
 */
export const MAIN = 'MAIN';

/** WORKAROUND TO SET VF Object */
const vfobject = typeof((<any>window).VF);

if ('undefined' === vfobject) {
    (<any>window).VF = {};
    (<any>window).VF = {
        siteStructure: ['foo', 'bar' ],
    };
}

/**
 * Export Namespace
 */
export const NAMESPACE = 'GLASFASERVFP';

import {required} from '@vfde-brix/core';

/**
 * Export REQUIRED_VALIDATION_CONFIG
 */
export const REQUIRED_VALIDATION_CONFIG = { validator: required, errorKey: 'required' };

/**
 * Site Structure coming from CMS (Nvaigation)
 */
export const ADDITIONAL_CMS_SITE_STRUCTURE = (<any>window).VF.siteStructure;

/**
 * Tracking Constant for logged in
 */
export const TRACKING_LOGGED_IN = 'logged in';
/**
 * Tracking Constant for not logged in
 * ToDo: Can this be handled in core?
 */
export const TRACKING_NOT_LOGGED_IN = 'not logged in';
/**
 * siteArea stands for product category
 */
export const TRACKING_SITE_AREA_MOBILITY = 'fiber';

/**
 * siteArea stands for product category
 */
export const TRACKING_AVAILABLE_PRODUCTS_CABLE = 'cable-fiber';

/**
 * Platform type - always responsiv for sails
 * ToDo: Can this be moved to core?
 */
export const TRACKING_PLATFORM_TYPE_RESPONSIVE = 'responsive';

/**
 * PageType
 */
export const TRACKING_PAGE_TYPE = 'content';

/**
 * Tracking form type
 */
export const TRACKING_FORM_TYPE = 'Availability Check';

/**
 * Tracking form type
 */
export const TRACKING_FORM_SUCCESS_FIBER = 'Available fiber';

/**
 * Tracking form type
 */
export const TRACKING_FORM_SUCCESS_CABLE = 'Available cable-fiber';

/**
 * Tracking form type
 */
export const TRACKING_FORM_FAILED = 'Not Available';

/**
 * Wording Service of Glasfaser is not available
 */
export const GLASFASER_SERVICE_NOT_AVAILABLE = 'Wir arbeiten schon an der L&ouml;sung. Versuch es bitte nochmal. Oder starte die Verf&uuml;gbarkeitspr&uuml;fung zu einem sp&auml;teren Zeitpunkt.';

/**
 * ZIPCODE_ID
 */
export const INPUT_ZIPCODE_ID = 'input-zipcode';

/**
 * CITY_ID
 */
export const INPUT_CITY_ID = 'input-city';

/**
 * STREET_ID
 */
export const INPUT_STREET_ID = 'input-street';

/**
 * HOUSE_NUMBER_ID
 */
export const INPUT_HOUSE_NUMBER_ID = 'input-house-number';

/**
 * TOGGLE_LINK
 */
export const LINK_TOGGLE_CLASS = 'container-reset';

/**
 * TOGGLE_LINK Button: Reset
 */
export const LINK_TOGGLE_RESET_BUTTON_CLASS = 'reset-button';

/**
 * TOGGLE_LINK Button: Redirect
 */
export const LINK_TOGGLE_REDIRECT_BUTTON_CLASS = 'redirect-button';

/**
 * ZIPCODE_ID
 */
export const CONTAINER_ZIPCODE = 'container-zipcode';

/**
 * CITY_ID
 */
export const CONTAINER_CITY = 'container-city';

/**
 * STREET_ID
 */
export const CONTAINER_STREET = 'container-street';

/**
 * HOUSE_NUMBER_ID
 */
export const CONTAINER_HOUSE_NUMBER = 'container-house-number';

/**
 * CONTAINER SUBMIT BUTTON
 */
export const CONTAINER_SUBMIT = 'container-submit';

/**
 * CONTAINER FORM
 */
export const CONTAINER_FORM = 'container-glasfaser-form';

/**
 * CONTAINER RESULT
 */
export const CONTAINER_RESULT = 'container-glasfaser-result';

/**
 * CONTAINER AVAILABILITY CHECK FAILED
 */
export const CONTAINER_AVAILABILITY_CHECK_FAILED = 'availablitiy-check-failed';

/**
 * CONTAINER AVAILABILITY CHECK SUCCEED
 */
export const CONTAINER_AVAILABILITY_CHECK_SUCCEED = 'availablitiy-check-succeed';

/**
 * CONTAINER AVAILABILITY CHECK SUCCEED
 */
export const CONTAINER_AVAILABILITY_CHECK_CABLE_SUCCEED = 'availablitiy-check-succeed-cable';

/**
 * CONTAINER AVAILABILITY CHECK SUCCEED
 */
export const CONTAINER_AVAILABILITY_SERVICE_NOT_AVAILABLE = 'availablitiy-check-service-not-available';

/**
 * CONTAINER ADDRESS-FROM-FORM
 */
export const CONTAINER_ADDRESS_FROM_FORM = 'address-from-form';

/**
 * CONTAINER ADDRESS-FROM-SERVICE
 */
export const CONTAINER_ADDRESS_FROM_SERVICE = 'address-from-service';

/**
 * CONTAINER CABLE_ADDRESS_FROM_SERVICE
 */
export const CONTAINER_CABLE_ADDRESS_FROM_SERVICE = 'address-from-service-cable';

/**
 * CONTAINER DEFAULT CONTENT
 */
export const CONTAINER_DEFAULT_CONTENT = 'container-default-content';

/**
 * CONTAINER USER ROUTING
 */
export const CONTAINER_USER_ROUTING = 'container-user-routing';

/**
 * CONTAINER_DEFAULT_CONTENT_CABLE
 */
export const CONTAINER_DEFAULT_CONTENT_CABLE = 'container-default-content-cable';

/**
 * CONTAINER EWA CONTENT ON SUCCESS
 */
export const CONTAINER_EWA_CONTENT = 'container-ewa-content';

/**
 * CONTAINER WILIE CONTENT ON SUCCESS
 */
export const CONTAINER_WILUE_CONTENT = 'container-wilue-content';

/**
 * CONTAINER CONTAINER_NOTIFICATION_FAILED
 */
export const CONTAINER_NOTIFICATION_FAILED = 'container-notification-failed';

/**
 * CONTAINER CONTAINER_NOTIFICATION_SUCCESS
 */
export const CONTAINER_NOTIFICATION_SUCCESS = 'container-notification-success';

/**
 * CONTAINER CONTAINER_NOTIFICATION_SUCCESS_CABLE
 */
export const CONTAINER_NOTIFICATION_SUCCESS_CABLE = 'container-notification-success-cable';

/**
 * CONTAINER CONTAINER_NOTIFICATION_SUCCESS
 */
export const CONTAINER_NOTIFICATION_SERVICE_NOT_AVAILABLE = 'container-notification-service-not-available';

/**
 * CONTAINER LOADING-SPINNER
 */
export const LOADING_INDICATOR_CONTAINER = 'brix-loading-spinner-container';

/**
 * Session Storage Glasfaser-VFP Flow
 */
export const SESSION_STORAGE_GLASFASER_VFP_FLOW = 'glasfaser_vfp_result';
